"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatQueryString = formatQueryString;
exports.parseQueryString = parseQueryString;
exports.joinPath = joinPath;
const lodash_1 = require("lodash");
function formatQueryString(params) {
    if ((0, lodash_1.isEmpty)(params) || !params) {
        return "";
    }
    const searchParams = new URLSearchParams();
    const toStr = (x) => ((0, lodash_1.isNull)(x) || (0, lodash_1.isUndefined)(x) || ((0, lodash_1.isObject)(x) && (0, lodash_1.isEmpty)(x)) ? "" : String(x));
    Object.entries(params).forEach(([name, value]) => {
        if (Array.isArray(value)) {
            value.forEach((val) => searchParams.append(name, toStr(val)));
        }
        else {
            searchParams.set(name, toStr(value));
        }
    });
    return searchParams.toString();
}
function parseQueryString(qs) {
    const searchParams = new URLSearchParams(qs);
    const result = {};
    for (const [key, value] of searchParams.entries()) {
        if (!result[key]) {
            result[key] = value;
            continue;
        }
        if (result[key] instanceof Array) {
            result[key].push(value);
            continue;
        }
        if (typeof result[key] === "string") {
            result[key] = [result[key], value];
        }
    }
    return result;
}
function joinPath(...parts) {
    let path = parts
        .map((part) => String(part).replace(/^\/+|\/+$/g, ""))
        .filter((part) => part)
        .join("/");
    if (String(parts[0] || "").startsWith("/")) {
        path = `/${path}`;
    }
    if (String((0, lodash_1.last)(parts) || "").endsWith("/")) {
        path = `${path}/`;
    }
    return path;
}
//# sourceMappingURL=url.js.map